module.exports = __webpack_public_path__ + "c9b5bcb31972d8f1d946a4841f670f4b.png";